


























































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import VCheckButton from '@/components/VCheckButton.vue';
import ClickOutside from '../directives/ClickOutside';
import VInlineDateInput from '@/components/VInlineDateInput.vue';
import moment from 'moment';
import VIcon from "../components/VIcon.vue";
import { ENTER } from '@/utils/KeyboardHelper';
import { v1 as uuid } from 'uuid';
import {

  UK_DATE_FORMAT_DASHED
} from '@/utils/DateHelper';
import NoCache from '@/decorators/NoCache';

export interface DatePickerData {
  date?: number | null;
}

@Component({
  components: {
    VCheckButton,
    VIcon,
    VInlineDateInput
  },
  directives: {
    ClickOutside
  }
})
export default class VInlineDatePicker extends Vue {
  @Prop({ default: null }) readonly date?: number | null;
  @Prop({ default: null }) readonly placeholder?: string | null;
  @Prop({ default: false }) readonly disabled?: boolean;
  @Prop({ default: 'left' }) readonly dropdownAlign?: string;
  @Prop({}) readonly value!: string;

  private mode = 'single';
  @Watch('date')
  onDateChange(value: number | null) {
    if (this.date !== value) {
      this.dateOne = value;
    }
  }

  dateOne: number | null = null;
  protected datepicker: any = null;
  visible = false;
  firstOpen = true;

  subscription: any = null;

  private opened = false;
  private lastKey = `airbnb-date-picker-${this.dateOne}`;

  subscribe() {
    this.subscription = (e: KeyboardEvent) => {
      if (e.key === ENTER) {
        if (this.dateOne && !Number.isNaN(this.dateOne)) {
          this.$emit('blur');
        }
      }
    };

    window.addEventListener('keydown', this.subscription);
  }

  destroyed() {
    this.unsuscribe();
  }

  unsuscribe() {
    window.removeEventListener('keydown', this.subscription);
  }

  @NoCache
  get inlineDate() {
    return this.dateOne
      ? this.dateOne
      : new Date().getTime();
  }

  created() {
    this.dateOne = this.date || new Date().getTime();
    this.subscribe();
  }

  get inlineDateInputRef() {
    return `inlinedateInput-${uuid()}`;
  }

  @NoCache
  get timePickerDate() {
    return this.dateOne && !Number.isNaN(this.dateOne)
      ? moment(this.dateOne).format(UK_DATE_FORMAT_DASHED)
      : moment(new Date()).format(UK_DATE_FORMAT_DASHED);
  }

  @Watch('dateOne')
  onDateOneChanged(data: number | null) {
    if (data) {
      this.$emit('input', data);
    }
  }

  onInlineDateChanged(data: number) {
    this.dateOne = data;
  }

  mounted() {
    this.datepicker = this.$refs.datepicker;
    this.datepicker.width = 220;
  }

  get singleMode() {
    return this.mode === 'single';
  }

  get rangeMode() {
    return this.mode === 'range';
  }

  get monthsToShow() {
    return 1;
  }

  get randomValue() {
    return Math.random().toString(36).substr(2, 9);
  }

  get triggerId() {
    return 'datepicker-' + this.randomValue;
  }

  get dateOneChanged() {
    return this.dateOne !== this.date;
  }

  @NoCache
  get airbnbKey() {
    if (!this.opened) {
      this.lastKey = `airbnb-date-picker-${this.dateOne}`;
    }
    return this.lastKey;
  }

  toggleDropdown() {
    this.visible = !this.visible;

    if (!this.opened) {
      this.opened = true;
    }

    if (this.visible && this.firstOpen) {
      this.$nextTick(() => {
        if (this.datepicker) {
          this.datepicker.generateMonths();
          this.firstOpen = false;
        }
      });
    }
  }

  closeDropdown() {
    if (this.visible) {
      this.visible = false;
    }
  }

  confirmRange() {
    this.closeDropdown();
    if (this.dateOne) {
      this.emitSelected();
    }
  }

  emitSelected() {
    const data = {
      date: this.dateOne
    };
    this.$emit('selected', data);
  }

  onDateOneSelected(value: string) {
    if (value === 'Invalid Date') {
      this.dateOne = null;
    } else {
      this.dateOne = new Date(value).getTime();
    }
    this.$emit('date-selected', this.dateOne);
    if (this.singleMode && this.dateOneChanged) {
      this.emitSelected();
    }
  }

  onClosed() {
    if (this.rangeMode) {
      if (this.dateOne && this.dateOneChanged) {
        this.emitSelected();
      }
    }
  }
}
